export default "__VITE_ASSET__I96ZM0CF__"